import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Container from '../../../containers/master/activityClasses/editActivityClassContainer';
import { actions } from '../../../redux/master/activityClasses';

export default function () {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.getInitData({}));
  }, []);
  return (
    <Container />
  );
}
